import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

import translations from './useAddToCart.translations'

export const TOAST_PARAMS_BY_ERROR_TYPE: Record<
  string,
  { title: I18nDefinition; content: I18nDefinition }
> = {
  '/errors/cart/add-product-quantity': {
    title: translations.addProductQuantityErrorTitle,
    content: translations.addProductQuantityErrorDescription,
  },
  'cart/add-product-stock': {
    title: translations.addProductStockErrorTitle,
    content: translations.addProductStockErrorDescription,
  },
  '/errors/cart/add-service-to-bag/already-one-mobile-plan': {
    title: translations.alreadyOneMobilePlanErrorTitle,
    content: translations.alreadyOneMobilePlanErrorDescription,
  },
  '/errors/cart/add-service-to-bag/listing-quantity-invalid': {
    title: translations.alreadyOneMobilePlanErrorTitle,
    content: translations.alreadyOneMobilePlanErrorDescription,
  },
  '/errors/cart/add-service-to-bag/insufficient-remaining-balance': {
    title: translations.insufficientRemainingBalanceErrorTitle,
    content: translations.insufficientRemainingBalanceErrorDescription,
  },
  '/errors/cart/add-service-to-bag/mobile-plan-incompatible-with-promo-code': {
    title: translations.mobilePlanIncompatibleWithPromoCodeTitle,
    content: translations.mobilePlanIncompatibleWithPromoCodeDescription,
  },
  '/errors/cart/add-service-to-bag/promo-code-incompatible-with-mobile-plan': {
    title: translations.promoCodeIncompatibleWithMobilePlanTitle,
    content: translations.promoCodeIncompatibleWithMobilePlanDescription,
  },
}
